import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from '../ModalWrapper';

const WhsDiscrepanciesModal = ({
  isShown,
  onClose,
  onConfirm,
  discrepancies
}) => (
  <ModalWrapper
    isOpen={ isShown }
    title="Withholding Statement Discrepancies"
    subTitle="Please review the following information carefully."
    btnConfirmTitle="Submit"
    btnCancelTitle="Cancel"
    onConfirm={ onConfirm }
    onCancel={ onClose }
    modalSize="whs-discrepancies-modal"
  >
    <div>
      { discrepancies?.whsAccountRequirementChanged && (
        <div>
          <h2><strong>Withholding Statement Unlinked</strong></h2>
          <p>
            The account’s position has changed and <strong>no longer requires a withholding statement</strong>.
            <br />
            As a result, the associated withholding statement will be <strong>unlinked</strong> from this account and will become <strong>non-editable</strong>.
            <br />
            This ensures that only relevant documentation remains active for reporting and compliance purposes.
            <br />
            Please review any impacted accounts to confirm withholding requirements are correctly reflected.
          </p>
        </div>
      )}
      { discrepancies?.coverageGapDetected && (
        <div>
          <h2><strong>Withholding Statement Coverage Gap Detected</strong></h2>
          <p>
            The effective-to date of the most recent published withholding statement ends <strong>before</strong> the sign date of the newly submitted form.
            <br />
            This creates a <strong>gap in withholding statement coverage</strong>, which may impact the accuracy of tax reporting and compliance.
            <br />
            Please review the withholding documentation to ensure continuous coverage. If necessary, update or request a new statement to bridge the gap.
          </p>
        </div>
      )}
      { discrepancies?.effectiveToAdjustmentsRequired && (
        <div>
          <h2><strong>Withholding Statement Effective Date Adjustment</strong></h2>
          <p>
            The currently effective withholding statement has an effective-to date <strong>after</strong> the sign date of the newly submitted form.
            <br />
            To maintain accurate reporting and avoid overlapping coverage, the effective-to date of the existing withholding statement will be <strong>automatically adjusted</strong> to the <strong>day before</strong> the sign date of the new form.
            <br />
            Please review the updated dates to ensure they align with your documentation and compliance requirements.
          </p>
        </div>
      )}
      { discrepancies?.futureDatedWhsDetected && (
        <div>
          <h2><strong>Future-Dated Withholding Statements Will Be Removed</strong></h2>
          <p>
            One or more published withholding statements have effective date ranges that <strong>start and end in the future</strong>.
            <br />
            These statements are no longer relevant and will be <strong>automatically deleted</strong> to maintain accurate and current withholding documentation.
            <br />
            Please ensure that any necessary updates are made to reflect valid withholding coverage.
          </p>
        </div>
      )}
      { discrepancies?.linkedAccountsDetected && (
        <div>
          <h2><strong>Linked Accounts Affected</strong></h2>
          <p>
            This withholding statement is linked to <strong>other accounts</strong>.
            <br />
            Any changes or gaps in coverage will also apply to those linked accounts and may affect their reporting and compliance status.
            <br />
            Please ensure all associated accounts are reviewed and updated accordingly to maintain accurate withholding documentation.
          </p>
        </div>
      )}
    </div>
  </ModalWrapper>
);

WhsDiscrepanciesModal.propTypes = {
  isShown: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  discrepancies: PropTypes.shape({
    coverageGapDetected: PropTypes.bool,
    effectiveToAdjustmentsRequired: PropTypes.bool,
    futureDatedWhsDetected: PropTypes.bool,
    linkedAccountsDetected: PropTypes.bool,
    whsAccountRequirementChanged: PropTypes.bool
  })
};

WhsDiscrepanciesModal.defaultProps = {
  isShown: false,
  discrepancies: null
};

const mapStateToProps = (state) => {
  const {
    forms: {
      whsFormDiscrepancies
    }
  } = state;

  return {
    discrepancies: whsFormDiscrepancies
  };
};

export default connect(mapStateToProps)(WhsDiscrepanciesModal);
